import 'react-app-polyfill/ie11';import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import InvitedList from './components/invited/InvitedList';
import UserAdd from './components/UserAdd';
import EventAddLayout from './layout/EventAddLayout';
import PublicEventAddLayout from './layout/PublicEventAddLayout';
import PublicEventEditLayout from './layout/PublicEventEditLayout';
import EventEditLayout from './layout/EventEditLayout';
import EventChangeLayout from './layout/EventChangeLayout';
import PrivateRoute from './components/PrivateRoute';
import LoginLayout from './layout/LoginLayout';
import PasswordForgottenLayout from './layout/PasswordForgottenLayout';
import PasswordResetLayout from './layout/PasswordResetLayout';
import HomeLayout from './layout/HomeLayout';
import RegistrationLayout from './layout/RegistrationLayout';
import AgbLayout from './layout/AgbLayout';
import PasswordChangeLayout from './layout/PasswordChangeLayout';
import PublicEventShowItemLayout from './layout/PublicEventShowItemLayout';
import ProfileLayout from './layout/ProfileLayout';
import MyEventsLayout from './layout/MyEventsLayout';
import MyFavoritesLayout from './layout/MyFavoritesLayout';
import MyBookedsLayout from './layout/MyBookedsLayout';
import SubscriptionsLayout from './layout/SubscriptionsLayout';
import OtherEventsLayout from './layout/OtherEventsLayout';
import MyInvitationsLayout from './layout/MyInvitationsLayout';
import SearchPublicEventLayout from './layout/SearchPublicEventLayout';
import MyEventFavoritesLayout from './layout/MyEventFavoritesLayout';

import MyPublicEventsLayout from './layout/MyPublicEventsLayout';
import BookedLayout from './layout/BookedLayout';
import TemplatesLayout from './layout/TemplatesLayout';
import EventCloneLayout from './layout/EventCloneLayout';
import PublicEventCloneLayout from './layout/PublicEventCloneLayout';
import RegValidateLayout from './layout/RegValidateLayout';
import ParametersLayout from './layout/ParametersLayout';
import UserAdminLayout from './layout/UserAdminLayout';
import SearchActivityLayout from './layout/SearchActivityLayout';
import EventSubscriptionsLayout from './layout/EventSubscriptionsLayout';
import AlarmInfoLayout from './layout/AlarmInfoLayout';
import AdminPublicEventLayout from './layout/AdminPublicEventLayout';
import AdminPrivateEventLayout from './layout/AdminPrivateEventLayout';
import AdminActivityLayout from './layout/AdminActivityLayout';
import AdminStatisticsLayout from './layout/AdminStatisticsLayout';





import { createStore } from 'redux'
import { Provider } from 'react-redux';
import reduce from './reducers/index';
import './css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {HashRouter, Route} from 'react-router-dom';

import { I18nextProvider } from "react-i18next";

import i18n from "./i18n";

/*
<!-- Simple Line Icons -->
	<link rel="stylesheet" href="assets/css/simple-line-icons.css">
	<!-- AOS -->
	<link rel="stylesheet" href="assets/css/aos.css">
	<!-- Custom -->
	<link rel="stylesheet" href="assets/css/style.css">
*/

//import * as serviceWorker from './serviceWorker';

/*

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
*/
/*i18n.init({
  interpolation: { escapeValue: false },  // React already does escaping
});

<Navigation />
*/


let store = createStore(reduce);
// <Route path="/wish" component={WishList}></Route>
ReactDOM.render(
  <I18nextProvider i18n={i18n}>
  <Provider store={store}>
    <HashRouter>
      <div>
        <Route exact={true} path="/" component={HomeLayout}></Route>
        <Route path="/home" component={HomeLayout}></Route>
        <Route path="/search" component={SearchPublicEventLayout}></Route>
        <Route path="/searchActivity" component={SearchActivityLayout}></Route>
       
        <Route path="/registration" component={RegistrationLayout}></Route>
        <Route path="/eventAdd" component={EventAddLayout}></Route>
        <Route path="/pubEventAdd" component={PublicEventAddLayout}></Route>
        <Route path="/pubEventEdit/:id" component={PublicEventEditLayout}></Route>
        <Route path="/pubEventClone/:id" component={PublicEventCloneLayout}></Route>
        <Route path="/eventEdit/:id" component={EventEditLayout}></Route>
        <Route path="/eventChange/:id" component={EventChangeLayout}></Route>
        <Route path="/eventClone/:id" component={EventCloneLayout}></Route>
        <Route path="/invited" component={InvitedList}></Route>
        <Route path="/userAdd" component={UserAdd}></Route>
        <Route path="/loginPage/:id" component={LoginLayout}></Route>
        <Route path="/checkLogin/:id/:idx" component={LoginLayout}></Route>
        <Route path="/passwordForgotten" component={PasswordForgottenLayout}></Route>
        <Route path="/pwdReset/:userId/:uuid" component={PasswordResetLayout}></Route>
        <Route path="/regValidate/:userId/:uuid" component={RegValidateLayout}></Route>
        <Route path="/agb" component={AgbLayout}></Route>
        <Route path="/myevents/:id" component={MyEventsLayout}></Route>
        <Route path="/favorites/:id" component={MyFavoritesLayout}></Route>
        <Route path="/booked/:id" component={MyBookedsLayout}></Route>
        <Route path="/eventFavorites/:id" component={MyEventFavoritesLayout}></Route>
        
        <Route path="/subscriptions/:id" component={SubscriptionsLayout}></Route>
        <Route path="/eventSubscriptions/:id" component={EventSubscriptionsLayout}></Route>
        <Route path="/otherEvents/:id" component={OtherEventsLayout}></Route>
        <Route path="/myinvitations/:id" component={MyInvitationsLayout}></Route>
        <Route path="/showevent/:id" component={PublicEventShowItemLayout}></Route>
        <Route path="/myPublicEvent/:id" component={MyPublicEventsLayout}></Route>
        <Route path="/booked/:id/:title" component={BookedLayout}></Route>
        <Route path="/templates/:id" component={TemplatesLayout}></Route>
        <Route path="/parameters" component={ParametersLayout}></Route>
        <Route path="/userAdmin" component={UserAdminLayout}></Route>
        <Route path="/alarmInfo" component={AlarmInfoLayout}></Route>
        <Route path="/adminPublicEvents" component={AdminPublicEventLayout}></Route>
        <Route path="/adminPrivateEvents" component={AdminPrivateEventLayout}></Route>
        <Route path="/adminActivities" component={AdminActivityLayout}></Route>
        <Route path="/adminStatistics" component={AdminStatisticsLayout}></Route>

        
        <PrivateRoute exact path="/login" component={HomeLayout} />
        <PrivateRoute exact path="/pwdChange" component={PasswordChangeLayout} />
        <PrivateRoute exact path="/profile" component={ProfileLayout} />
      </div>
    </HashRouter>
  </Provider>
  </I18nextProvider>
  ,
  document.getElementById('root')
);

export default store;